import { render, staticRenderFns } from "./lrModifyuser.vue?vue&type=template&id=1f89e672"
import script from "./lrModifyuser.vue?vue&type=script&lang=js"
export * from "./lrModifyuser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports